"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_native_1 = require("react-native");
const colors_1 = __importDefault(require("../../styles/colors"));
const styles = react_native_1.StyleSheet.create({
    text: {
        color: colors_1.default.FONT_BLACK,
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: 18,
        lineHeight: 24,
    },
});
exports.default = styles;
